import { render, staticRenderFns } from "./approval-history.vue?vue&type=template&id=ea773588"
import script from "./approval-history.vue?vue&type=script&lang=js"
export * from "./approval-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports